<script lang="ts">
	import AppScreen from './AppScreen.svelte'
	import { Motion } from 'svelte-motion'
	import { blockTypes } from '$lib/utils/defaultValues'
	import { fade } from 'svelte/transition'
	import PanelBody from '$lib/components/itineraries/PanelBody.svelte'
	import PanelHeader from '$lib/components/itineraries/PanelHeader.svelte'
	import SleekButton from '$lib/components/buttons/SleekButton.svelte'
	import ExIcon from '$lib/components/icons/ExIcon.svelte'
	interface Props {
		[key: string]: any
	}

	let { ...props }: Props = $props()
</script>

<AppScreen>
	<Motion {...props}>
		{#snippet children({ motion })}
			<div
				class="absolute bottom-0 w-full left-0 right-0 bg-brand-gray-5 h-2/3 rounded-t-xl z-20"
				use:motion
			>
				<PanelHeader
					class="rounded-t-xl bg-brand-gray-6 dark:bg-brand-gray-6 dark:lg:bg-brand-gray-6"
				>
					<div class="flex items-center text-sm font-medium text-black dark:text-white">
						<p>Add to Trip</p>
					</div>

					<SleekButton onclick={null}>
						<ExIcon class="h-4 w-4 m-auto text-black dark:text-white" />
					</SleekButton>
				</PanelHeader>

				<PanelBody>
					<div class="px-2 flex flex-col items-start mt-4 space-y-2 w-full">
						{#each blockTypes as item, index (item.title)}
							<div in:fade={{ delay: index * 100, duration: 400 }} class="w-full">
								<button
									class={`flex items-center group cursor-pointer w-full py-1 overflow-x-hidden truncate mr-4`}
								>
									<div
										class={`w-8 h-8 flex items-center justify-center rounded-md object-cover flex-shrink-0 ${item?.bgColor}`}
									>
										<img class={`'w-5 h-5 p-auto`} src={item?.iconUrl} alt={item?.title} />
									</div>
									<div class="px-4 text-start w-full">
										<div
											class={`text-sm font-medium dark:text-brand-gray-2 group-hover:dark:text-white text-black w-full
				whitespace-break-spaces`}
										>
											{@html item?.title}
										</div>
										<p
											class={`text-xs dark:text-brand-gray-3 group-hover:dark:text-brand-gray-2 text-brand-gray-5 w-full whitespace-break-spaces`}
										>
											{@html item?.description ?? 'No description available'}
										</p>
									</div>
								</button>
							</div>
						{/each}
					</div>
				</PanelBody>
			</div>
		{/snippet}
	</Motion>
</AppScreen>
